const FactorTypes = {
	F_WINNER       : -2,
	F_OUTCOMES     : 1,
	F_DBL_CHANCE   : 2,
	F_FORA         : 3,
	F_TOTAL        : 4,
	F_I_TOTAL      : 5,
	F_TEAM         : 6,
	F_I_TEAM       : 7,
	F_BOOL         : 8,
	F_I_BOOL       : 9,
	F_SCORES       : 10,
	F_GAMES        : 11,
	F_EFFECTIVE    : 12,
	F_PERIOD_M     : 13,
	V_LOWER        : 1,
	V_UPPER        : 2,
	V_FIRST        : 1,
	V_SECOND       : 2,
	V_DRAW         : 0,
	V_EXCEPT       : 0,
	V_FIRST_LOWER  : 11,
	V_FIRST_UPPER  : 12,
	V_SECOND_LOWER : 21,
	V_SECOND_UPPER : 22,
	V_NO           : 1,
	V_YES          : 2,
	V_FIRST_NO     : 11,
	V_FIRST_YES    : 12,
	V_SECOND_NO    : 21,
	V_SECOND_YES   : 22,
};

export default FactorTypes;


// WEBPACK FOOTER //
// ./src/app/constants/FactorTypes.js